module.exports = __webpack_public_path__ + "img/carshina21_27.cb1b0d7c.jpg";